"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionsControllerSwapSportV1200Response = instanceOfSubscriptionsControllerSwapSportV1200Response;
exports.SubscriptionsControllerSwapSportV1200ResponseFromJSON = SubscriptionsControllerSwapSportV1200ResponseFromJSON;
exports.SubscriptionsControllerSwapSportV1200ResponseFromJSONTyped = SubscriptionsControllerSwapSportV1200ResponseFromJSONTyped;
exports.SubscriptionsControllerSwapSportV1200ResponseToJSON = SubscriptionsControllerSwapSportV1200ResponseToJSON;
exports.SubscriptionsControllerSwapSportV1200ResponseToJSONTyped = SubscriptionsControllerSwapSportV1200ResponseToJSONTyped;
var ReorderSportsResponseDto_1 = require("./ReorderSportsResponseDto");
/**
 * Check if a given object implements the SubscriptionsControllerSwapSportV1200Response interface.
 */
function instanceOfSubscriptionsControllerSwapSportV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SubscriptionsControllerSwapSportV1200ResponseFromJSON(json) {
    return SubscriptionsControllerSwapSportV1200ResponseFromJSONTyped(json, false);
}
function SubscriptionsControllerSwapSportV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, ReorderSportsResponseDto_1.ReorderSportsResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function SubscriptionsControllerSwapSportV1200ResponseToJSON(json) {
    return SubscriptionsControllerSwapSportV1200ResponseToJSONTyped(json, false);
}
function SubscriptionsControllerSwapSportV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, ReorderSportsResponseDto_1.ReorderSportsResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
